import styled from "styled-components";
import { WidgetCard, Text } from "../../common";
import { media } from "../../../utils";

export const ResultsCard = styled(WidgetCard)`
  max-width: auto;
`;

export const ResultNumber = styled(Text)`
  text-align: center;
  margin: 0 1rem 1rem 0;
  color: ${({ theme }) => theme.color.brandPrimary.medium};
`;

export const DrawnNumbersButton = styled.button`
  width: 100%;
  ${media.md()} {
    width: auto;
  }
`;

export const ModalBody = styled.div`
  ${media.md()} {
    width: 60%;
  }
`;

export const NumbersResultListContent = styled.div``;
